import React from "react";
import { EnvironmentOutlined } from "@ant-design/icons";

const ResumeCard = ({
  title,
  fromDate,
  toDate,
  companyName,
  companyLogo,
  location,
  description,
  highlights,
  relevantTechnologies,
}) => {
  return (
    <article className="resume-card mx-auto" style={{ maxWidth: "950px" }}>
      <div className="mb-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <h2 className="text-lg font-bold text-brand-600 dark:text-brand-400 md:text-xl">{title}</h2>
        <span className="inline-flex w-fit rounded-full bg-brand-50 px-3 py-1 text-xs font-medium text-brand-800 ring-1 ring-brand-200/60 dark:bg-brand-950 dark:text-brand-200 dark:ring-brand-800 md:text-sm">
          {fromDate} – {toDate}
        </span>
      </div>

      <div className="mb-4 flex flex-col gap-2 sm:flex-row sm:items-center">
        <div className="flex items-center gap-3">
          <img
            src={companyLogo}
            alt={`${companyName} logo`}
            className="h-10 w-10 rounded-lg object-contain ring-1 ring-ink-100 dark:ring-ink-700"
          />
          <span className="text-base font-medium text-ink-800 dark:text-ink-200 md:text-lg">
            {companyName}
          </span>
        </div>
        <span className="flex items-center text-sm text-ink-500 dark:text-ink-400 md:text-base">
          <span className="mx-2 hidden text-ink-300 sm:inline">·</span>
          {location} <EnvironmentOutlined className="ml-1" />
        </span>
      </div>

      <div className="mb-4">
        <p className="leading-relaxed text-ink-600 dark:text-ink-300">{description}</p>
      </div>

      {highlights && (
        <div className="mb-4">
          <h3 className="mb-2 text-sm font-semibold uppercase tracking-wide text-ink-500 dark:text-ink-400">
            Highlights
          </h3>
          <ul className="space-y-2 border-l-2 border-brand-200 pl-4 dark:border-brand-800">
            {highlights.map((highlight, index) => (
              <li key={index} className="leading-relaxed text-ink-700 dark:text-ink-300">
                {typeof highlight === "string" ? highlight : highlight}
              </li>
            ))}
          </ul>
        </div>
      )}

      {relevantTechnologies && (
        <div>
          <h3 className="mb-2 text-sm font-semibold uppercase tracking-wide text-ink-500 dark:text-ink-400">
            Technologies
          </h3>
          <div className="flex flex-wrap gap-2">
            {relevantTechnologies.map((tech, index) => (
              <span key={index} className="tech-pill">
                {tech}
              </span>
            ))}
          </div>
        </div>
      )}
    </article>
  );
};

export default ResumeCard;
